module.exports = __webpack_public_path__ + "static/media/Lato-Black.77d35374.ttf";